
export default (startTime, endTime) => {

  if (!startTime || !endTime) {
    return true;
  }
  return false;
}